import { createContext, useContext, ReactNode, useMemo } from 'react';
import { speakingSessionRoomStructureStore } from 'store';
import { SpeakingSessionExaminerAvailabilityDto } from 'api/planning';

type ExaminerAvailabilitiesContextType = {
  examinersAvailabilities: SpeakingSessionExaminerAvailabilityDto[] | undefined;
  isFetchingAvailabilities: boolean;
  error: any;
  refetch: () => Promise<any>;
};

const ExaminerAvailabilitiesContext = createContext<ExaminerAvailabilitiesContextType | undefined>(undefined);

type ExaminerAvailabilitiesProviderProps = {
  speakingSessionId: number;
  children: ReactNode;
};

export const ExaminerAvailabilitiesProvider = ({
  speakingSessionId,
  children
}: ExaminerAvailabilitiesProviderProps) => {
  const {
    data: examinersAvailabilities,
    isFetching: isFetchingAvailabilities,
    error,
    refetch
  } = speakingSessionRoomStructureStore.service.speakingSessionRoomStructureApi.useGetExaminersAvailabilitiesQuery({
    speakingSessionId,
  });

  const value: ExaminerAvailabilitiesContextType = useMemo(() => ({
    examinersAvailabilities,
    isFetchingAvailabilities,
    error,
    refetch
  }), [examinersAvailabilities, isFetchingAvailabilities, error, refetch]);

  return (
    <ExaminerAvailabilitiesContext.Provider value={value}>
      {children}
    </ExaminerAvailabilitiesContext.Provider>
  );
};

export const useExaminerAvailabilities = (): ExaminerAvailabilitiesContextType => {
  const context = useContext(ExaminerAvailabilitiesContext);
  if (context === undefined) {
    throw new Error('useExaminerAvailabilities must be used within an ExaminerAvailabilitiesProvider');
  }
  return context;
};